import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchScholarships } from "../../../../actions/career.action";
import Header from "../../../../components/header/Header";
import { Loading, userTypes } from "../../../../utils/helpers/constants";
import RoundLoader from "../../../../components/loader/RoundLoader";
import Body from "./Body";

export default function Home() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchScholarships());
  }, []);

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const {
    career: { scholarships, scholarshipLoading, scholarshipDeleteStatusState },
  } = useSelector(({ careerReducer }) => ({
    career: careerReducer,
  }));

  const loadState =
    scholarshipLoading === Loading.FETCHING ||
    profile.userProfileLoading === Loading.FETCHING;

  return (
    <div className="">
      <div>
        {loadState ? (
          <RoundLoader />
        ) : (
          <>
            <Body
              profile={profile}
              scholarshipLoading={scholarshipLoading}
              scholarships={scholarships}
              deleteStatusState={scholarshipDeleteStatusState}
            />
          </>
        )}
      </div>
    </div>
  );
}
